export default function CPointerArithmetic() {
  return <h2>C Pointer Arithmetic</h2>;
}
